module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-merge-zone"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-12 large-6"
  }, [_c('label', [_vm._v("How many geoJson to merge?")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numOfTextArea),
      expression: "numOfTextArea"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.numOfTextArea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numOfTextArea = $event.target.value
      }
    }
  })])]), _vm._l((_vm.numGeoJsonToMerge), function(n) {
    return (_vm.numGeoJsonToMerge.length > 0) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("GeoJson" + _vm._s(n))]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.geoJsonToMerge['geo' + n]),
        expression: "geoJsonToMerge['geo'+n]"
      }],
      attrs: {
        "rows": "10",
        "name": 'geo' + n
      },
      domProps: {
        "value": (_vm.geoJsonToMerge['geo' + n])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.geoJsonToMerge, 'geo' + n, $event.target.value)
        }
      }
    })])]) : _vm._e()
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "colomn"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.disable
    },
    on: {
      "click": _vm.mergeGeoJson
    }
  }, [_vm._v("Merge")])])]), (Object.keys(_vm.geoJsonToMerge).length !== 0 && _vm.spin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('textarea', {
    attrs: {
      "id": "geoJsonToCopy",
      "rows": "30"
    },
    domProps: {
      "value": _vm.mergedGeoJson
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_vm._v("Copy to clipboard")])])])])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b5d66c7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/MergeZone.vue
// module id = 2280
// module chunks = 1